/** Thai strings for this area (English source text -> Thai). */
export const COMMON: Record<string, string> = {
  // App: boot, toasts, invite note
  'Sharpening pencils… {pct}%': 'กำลังเหลาดินสอ… {pct}%',
  '{name} challenged you! Open Battle With Friends.': '{name} ท้าสู้กับคุณ! ไปที่ "สู้กับเพื่อน" เลย',
  '{name} wants to be your friend! See Notebook → Friends.': '{name} อยากเป็นเพื่อนกับคุณ! ดูที่ สมุด → เพื่อน',
  'You and {name} are now friends!': 'คุณกับ {name} เป็นเพื่อนกันแล้ว!',
  "{name} can't battle right now. Maybe next recess!": '{name} ยังสู้ตอนนี้ไม่ได้ ไว้ช่วงพักรอบหน้านะ!',
  'Your notebook was restored from its backup copy.': 'กู้สมุดของคุณคืนจากสำเนาสำรองแล้ว',
  'Battle invite from {name}': 'คำชวนสู้จาก {name}',
  'invites you to a battle!': 'ชวนคุณมาสู้กัน!',
  'Join!': 'เข้าร่วม!',
  'Not now': 'ไว้ก่อนนะ',

  // Shared dialog buttons (ui/components)
  Yes: 'ใช่',
  Cancel: 'ยกเลิก',
  OK: 'ตกลง',

  // Save errors (GameStore)
  'Your notebook is full! Delete some drawings to keep saving.': 'สมุดเต็มแล้ว! ลบรูปวาดบางรูปก่อนจะได้บันทึกต่อได้',
  'Could not save the notebook.': 'บันทึกสมุดไม่สำเร็จ',

  // Networking: friendly errors
  'The server sent a scribble we could not read.': 'เซิร์ฟเวอร์ส่งอะไรยึกยือมา อ่านไม่ออกเลย',
  'Request failed ({status})': 'ส่งคำขอไม่สำเร็จ ({status})',
  'The server took too long to answer.': 'เซิร์ฟเวอร์ตอบช้าเกินไป',
  'Cannot reach the game server. Single-player still works!': 'ติดต่อเซิร์ฟเวอร์เกมไม่ได้ แต่ยังเล่นคนเดียวได้นะ!',
  'Could not connect to the battle server.': 'เชื่อมต่อเซิร์ฟเวอร์ต่อสู้ไม่ได้',
  'Opened in another tab — this tab is now offline.': 'เปิดเกมในแท็บอื่นแล้ว — แท็บนี้เลยออฟไลน์',
  'The server closed the connection.': 'เซิร์ฟเวอร์ตัดการเชื่อมต่อแล้ว',
  'Connection closed.': 'การเชื่อมต่อถูกปิดแล้ว',
  'Connection lost.': 'การเชื่อมต่อหลุด',
  'Not connected to the battle server.': 'ยังไม่ได้เชื่อมต่อเซิร์ฟเวอร์ต่อสู้',
  'The server did not answer in time.': 'เซิร์ฟเวอร์ไม่ตอบกลับทันเวลา',
  'Server unavailable': 'ตอนนี้ใช้เซิร์ฟเวอร์ไม่ได้',

  // Nickname prompt (session)
  'Pick a nickname': 'ตั้งชื่อเล่น',
  'Friends will see this name': 'เพื่อน ๆ จะเห็นชื่อนี้',

  // Sharing monsters (share)
  'Shared {name}': 'แชร์ {name} แล้ว',
  'Share code {code}': 'รหัสแชร์ {code}',
  'Saved as a file for a friend.': 'บันทึกเป็นไฟล์ไว้ให้เพื่อนแล้ว',
  'Share failed': 'แชร์ไม่สำเร็จ',
  'Server offline — saved a monster file you can send to a friend instead.': 'เซิร์ฟเวอร์ออฟไลน์ — เลยบันทึกไฟล์มอนสเตอร์ไว้ให้ส่งให้เพื่อนแทน',
};
